import React, { useState } from 'react'
import PropTypes from 'prop-types'

import Stepbar from '@components/stepbar/stepbar'
import Header from '@components/layout/header'
import Footer from './footer'

import { Main, Intro, SafeArea, ValidationWarning } from './layout-style'

import Form from '@components/form/form'
import { StepOrder } from '@constants/StepOrderEnum'
import Layout from './layout'

const TemplateStep = ({ children, disableConfirmButton, externalValidations }) => {
  const [_disableConfirmButton, setDisableConfirmButton] = useState(disableConfirmButton)
  const [currentStep, setCurrentStep] = useState(1)

  const isFirstStep = currentStep === StepOrder.CompanyStep

  return (
    <Layout onChangeStep={setCurrentStep}>
      <Header />
      <SafeArea>
        <Intro>
          <p>Seja bem vindo.</p>
          <small>Conclua o cadastro para conectar nossos serviços ao seu negócio.</small>
        </Intro>
        <Stepbar currentStep={currentStep} />
        <Form onValidationChange={setDisableConfirmButton}>
          <ValidationWarning>Campos com * são de preenchimento obrigatório</ValidationWarning>
          <Main>{children}</Main>
          <Footer
            currentStep={currentStep}
            disableConfirmButton={_disableConfirmButton || externalValidations?.some(Boolean)}
            hasBackButton={!isFirstStep}
          />
        </Form>
      </SafeArea>
    </Layout>
  )
}

TemplateStep.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  disableConfirmButton: PropTypes.bool,
  externalValidations: PropTypes.arrayOf(PropTypes.bool),
}

export default TemplateStep
